module.exports = __webpack_public_path__ + "static/media/match.2728310f.mp3";